import { Faq } from '../types/homepage'

export const faqs: Faq[] = [
  {
    question: 'Is Re:Joy available now?',
    answer: 'Re:Joy is in development. You can join the waitlist for updates.',
  },
  {
    question: 'Who leads the therapy?',
    answer:
      'Re:Joy is being built around human therapists who lead care, including group sessions.',
  },
  {
    question: 'What is Joy’s role?',
    answer:
      'Joy is an AI assistant being designed to support intake and coordination. Joy is not a therapist.',
  },
  {
    question: 'Will Re:Joy include biometrics?',
    answer:
      'We’re working on incorporating biometric information, such as heart rate, sleep, and activity, to add context to care.',
  },
  {
    question: 'Does joining the waitlist start treatment?',
    answer:
      'No. Joining the waitlist expresses interest in Re:Joy; it does not begin treatment.',
  },
]
